import React from 'react';
import __ from 'lodash';

class DropdownReset extends React.Component{

    renderDropdown(){
        return (
            <div>
                <select className="form-control" onChange={this.onDropdownChange}>
                    <option value="" disabled selected>Pilih Aksi</option>
                    <option value={"rPassword-"+this.props.reset.idSiswa+"-"+this.props.reset.namaSiswa} >Reset Password</option>
                    <option value={"gantiPassword-"+this.props.reset.idSiswa+"-"+this.props.reset.namaSiswa} >Ganti Password</option>
                    <option value={"rHomework-"+this.props.reset.idSiswa+"-"+this.props.reset.namaSiswa} >Reset HomeWork</option>
                    <option value={"rExam-"+this.props.reset.idSiswa+"-"+this.props.reset.namaSiswa} >Reset Exam</option>
                </select>
            </div>
        )
    }

    onDropdownChange = (event) => {
        if(event.target.value === ""){
            this.props.onChange(null);
        }else{
            this.props.onChange(event.target.value);
            this.props.doSiswaSelected(this.props.reset);
        }
    }

    render(){
        return(
            <div>
                {this.renderDropdown()}
            </div>
        )
    }
}

export default DropdownReset;